module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "width": "50px",
      "vertical-align": "middle"
    }
  }, [_c('router-link', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "to": {
        path: '/Investigation/' + _vm.investigation.investigationId
      },
      "tag": "a"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Investigation DBI No.")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.investigation.dbNumber))])]), _vm._v(" "), (_vm.investigation.currentWorkflowStatusId === 3350) ? _c('span', [_c('span', {
    staticClass: "value",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("NOT ACCEPTED")])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Activities")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, _vm._l((_vm.investigationTypes), function(type, index) {
    return _c('span', {
      key: index,
      class: {
        'red-text': type.investigationTypeDescription === 'EO 14156'
      }
    }, [_vm._v("\n                " + _vm._s(type.investigationTypeDescription)), (index < _vm.investigationTypes.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "header_margin"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Report Title")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.investigation.reportTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invMigrationRefs.length > 0),
      expression: "invMigrationRefs.length > 0"
    }]
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Migrated References")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('v-client-table', {
    staticStyle: {
      "display": "inline-block",
      "margin": "auto",
      "min-width": "50%"
    },
    attrs: {
      "data": _vm.invMigrationRefs,
      "columns": _vm.gridInvMigrationRef.columns,
      "options": _vm.gridInvMigrationRef.options
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e201ad8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestigationHeader.vue
// module id = 934
// module chunks = 1